import type { CourseImportRequest } from '@golf-app/shared';

export interface PickerHoleCardEntry {
  number: number;
  par: number;
  handicap: number;
  yards?: number | null;
}

type ImportHoleCard = CourseImportRequest['tees'][number]['holes'];

/**
 * Preserves a catalog card exactly when a local course is reused. Generated
 * fallback cards receive sequential numbers only because no source identity
 * exists yet.
 */
export function buildImportHoleCard(
  holes: readonly PickerHoleCardEntry[],
  fallback: readonly Omit<PickerHoleCardEntry, 'number' | 'yards'>[],
): ImportHoleCard {
  const source: readonly PickerHoleCardEntry[] = holes.length > 0
    ? holes
    : fallback.map((hole, index) => ({ ...hole, number: index + 1 }));

  return source.map((hole) => ({
    number: hole.number,
    par: hole.par,
    handicap: hole.handicap,
    ...(hole.yards == null ? {} : { yards: hole.yards }),
  }));
}
